import {isLoggedIn} from 'utils/auth'

export default (store, keycloak) => ({
  path: 'field-sales-assist',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./components/FieldSalesAssist').default
      callback(null, component)
    }, 'FieldSalesAssist')
  },
  keycloak
})



// WEBPACK FOOTER //
// ./src/routes/FieldSalesAssist/index.js